export function IconUserSearch() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M20.5523 11.5523C21.0349 11.0697 21.3333 10.403 21.3333 9.66667C21.3333 8.19391 20.1394 7 18.6667 7C17.1939 7 16 8.19391 16 9.66667C16 11.1394 17.1939 12.3333 18.6667 12.3333C19.4031 12.3333 20.0697 12.0349 20.5523 11.5523ZM20.5523 11.5523L23 14M20.5523 11.5523L20.55 11.55M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
